export const SYNC_STATUS = {
  UNLINKED: 'UNLINKED',
  LINKED: 'LINKED',
  SYNCING: 'SYNCING',
  PAT_ERROR: 'PAT_ERROR',
  REPO_NOT_FOUND_ERROR: 'REPO_NOT_FOUND_ERROR'
};
